import { render } from "./Navbar.vue?vue&type=template&id=e0351208&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=e0351208&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e0351208"

export default script